'use strict';

module.exports = ['A/V Setup', 'Microphone', 'Piano Playing', 'Tent'];